import * as Yup from 'yup';

export const validationSchema = Yup.object({
  activityId: Yup.string().required('Activity ID is required'),
  score: Yup.number().required('Score is required').min(0, 'Score must be at least 0'),
  comment: Yup.string(),
  evidence: Yup.string(),
});
